export default __webpack_public_path__ + "static/media/us.5cc5f3b4.svg";